import { Injectable } from '@angular/core';
import { ItemBase } from './ecom-item-base/ecom-itembase';
import { OlarCashbackDiscountBase } from './ecom-olarcashbackdiscountbase';
import { ReferralBase } from './ecom-referralbase';
import { VoucherBase } from './ecom-voucherbase';

@Injectable()
export class StoreCartBase {
  orderId = '';
  orderItemsBeforeDiscount: ItemBase[] = [];
  orderItems: ItemBase[] = [];
  orderServiceCharge = 0;
  orderDeliveryCharge = 0;
  orderDeliveryTax = 0;
  orderTax = 0;
  orderSubTotal = 0;
  orderDiscountTotal = 0;
  orderDiscountTotalOADP = 0;
  orderTotal = 0;
  orderDiscountReferral = 0;
  //orderMerchantDiscount = 0;//referral discount and voucher discount currently
  orderCashbackOlar = 0;
  orderLoyalty = 0;
  cartEmpty = false;
  voucherAmount = 0;
  voucher: VoucherBase;
  referral: ReferralBase;
  olarDiscounts: OlarCashbackDiscountBase[];
  orderPickupCashback = 0;
  constructor(data?: Partial<StoreCartBase>) {
    Object.assign(this, data);
  }
}
